import VersionService from './service/service.version.es6.js';
import UtilityService from './service/service.utility.es6.js';
import UserAlarmController from '../package/system/orgchart/controller.UserAlarm.es6.js';
import UserApiDirective from '../package/system/orgchart/directive.UserApi.es6.js';
import UserFormDirective from '../package/system/orgchart/directive.UserForm.es6.js';
import {} from './service/service.hello.es6.js';
import {} from './directive/directive.logdb.js';

class Logpresso {
	static main() {

		window.Logpresso = window.Logpresso || {};
		window.Logpresso.VersionService = VersionService;
		window.Logpresso.UtilityService = UtilityService;
		window.Logpresso.getVersion =  window.Logpresso.getVersion || VersionService.getVersion;

		if(!!window.logpresso) {
			window.logpresso.controller('UserAlarmController', UserAlarmController);
			window.logpresso.directive('userApi', UserApiDirective);
			window.logpresso.directive('userForm', UserFormDirective);
		}
		else {
			throw new TypeError('cannot register controller');
		}
	}
}

Logpresso.main();


// WEBPACK FOOTER //
// ./resources/WEB-INF/script/logpresso.es6.js